import { useSelector } from 'react-redux';

import { IApplicationState } from '../../types/redux';

export const selectSpecialTabActive = (state: IApplicationState) => state.specialTabs.specialTabActive;

export const useSpecialTabActive = () => useSelector(selectSpecialTabActive);
